import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from '../../../../../../../../CommonComponents/OPL/Input/Input';

export const AccountDescription = () => {
  const formBag = useFormContext();
  const isOrion = formBag.watch('bankAccount.IsOrion');
  return (
    <Input
      {...formBag.register('bankAccount.AccountName')}
      label="Account Description"
      maxLength={32}
      disabled={isOrion}
    />
  );
};
